/* 🤖 this file was generated by script */
export const wiconBell01 = {
  name: 'bell_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.35 21a3.98 3.98 0 005.3 0M18 8A6 6 0 106 8c0 3.09-.78 5.2-1.65 6.6-.73 1.19-1.1 1.78-1.09 1.94.02.18.05.25.2.36.13.1.73.1 1.93.1H18.6c1.2 0 1.8 0 1.93-.1.15-.1.18-.18.2-.36.01-.16-.36-.75-1.09-1.93C18.78 13.2 18 11.09 18 8z"/></svg>`,
};
